<template>
  <a-modal
    ref="createModal"
    title="新增标准转换关系"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
    >
      <!-- 来源分类 -->
      <span slot="uomClassLabelTitle">
        <i class="toRequired">*</i>来源分类
      </span>
      <template slot="uomClass" slot-scope="text, record">
        <a-select show-search option-filter-prop="children" v-model="record.uomClass" @change="uomClassLabelOnChange(record)">
          <a-select-option v-for="(item) in uomClassOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
        </a-select>
      </template>
      <!-- 来源单位 -->
      <span slot="unitOfMeasureTitle">
        <i class="toRequired">*</i>来源单位
      </span>
      <template slot="unitOfMeasure" slot-scope="text, record">
        <a-select show-search option-filter-prop="children" v-model="record.unitOfMeasure">
          <a-select-option v-for="(item) in unitOfMeasureList" :key="item">{{ item }}</a-select-option>
        </a-select>
      </template>
      <!-- 折换 -->
      <span slot="conversionRateTitle">
        <i class="toRequired">*</i>折换
      </span>
      <template slot="conversionRate" slot-scope="text, record">
        <a-popover>
          <template slot="content">
            <p>即换算比例，1*折换*来源单位=1*基本单位</p>
          </template>
          <a-input-number v-model="record.conversionRate" :min="0" @blur="blur(record)" />
        </a-popover>
      </template>
      <!-- 倒数 -->
      <template slot="conversionRateInverse" slot-scope="text, record">
        <a-popover>
          <template slot="content">
            <p>即换算比例倒数，1*倒数*来源单位=1*基本单位</p>
          </template>
          <span>{{ record.conversionRateInverse }}</span>
        </a-popover>
      </template>
      <!-- 基本单位 -->
      <span slot="baseUnitOfMeasureTitle">
        <i class="toRequired">*</i>基本单位
      </span>
      <template slot="baseUnitOfMeasure" slot-scope="text, record">
        {{ record.baseUnitOfMeasure }}
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiMdmUomConversionsAdd, apiMdmUomConversionsClassToData } from '@/api/mdm/units/standard-unit'
// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 状态数据字典
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '来源分类',
          dataIndex: 'uomClass',
          scopedSlots: { customRender: 'uomClass', title: "uomClassLabelTitle" }
        },
        {
          // title: '来源单位',
          width: 150,
          dataIndex: 'unitOfMeasure',
          scopedSlots: { customRender: 'unitOfMeasure', title: "unitOfMeasureTitle" }
        },
        {
          // title: '折换',
          width: 150,
          dataIndex: 'conversionRate',
          scopedSlots: { customRender: 'conversionRate', title: "conversionRateTitle" }
        },
        {
          title: '倒数',
          dataIndex: 'conversionRateInverse',
          scopedSlots: { customRender: 'conversionRateInverse' }
        },
        {
          // title: '基本单位',
          dataIndex: 'baseUnitOfMeasure',
          scopedSlots: { customRender: 'baseUnitOfMeasure', title: "baseUnitOfMeasureTitle" }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      typeList: [],
      unitOfMeasureList: []
    }
  },
  created () {},
  methods: {
    // 列表-折换字段
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    // 来源分类-选择监听
    uomClassLabelOnChange (record) {
      const params = {
        uomClass: record.uomClass
      }
      apiMdmUomConversionsClassToData(params).then(res => {
        if (res.code === 200 && res.data) {
          record.baseUnitOfMeasure = res.data.baseUnitOfMeasure
          this.unitOfMeasureList = res.data.unitOfMeasureList
        }
      })
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        unitOfMeasure: "",
        uomClass: "",
        conversionRate: "",
        conversionRateInverse: "",
        baseUnitOfMeasure: "",
        status: "Y",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].unitOfMeasure) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
        if (!this.typeList[i].conversionRate || Number(this.typeList[i].conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiMdmUomConversionsAdd(this.typeList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 150px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
